import FileAttachmentButton from './FileAttachmentButton';

export default FileAttachmentButton;
